import { render, staticRenderFns } from "./ContactMessage.vue?vue&type=template&id=66d4afee&scoped=true&"
import script from "./ContactMessage.vue?vue&type=script&lang=js&"
export * from "./ContactMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4afee",
  null
  
)

export default component.exports